import { ClassroomModel, BoardModel, BoardsGroupModel, GroupModel } from '@descomplica/dex-models';

interface BoardClassroomDictionary {
  [boardId: number]: ClassroomModel;
}

export interface GroupWithClassrooms extends GroupModel {
  classrooms: ClassroomModel[];
}

export const createDictionaryBoardClassroom = (
  classrooms: ClassroomModel[],
): BoardClassroomDictionary => {
  const boardsClassroomDictionary: BoardClassroomDictionary = {};
  classrooms.forEach((classroom) => {
    classroom.boards.forEach((board: BoardModel) => {
      boardsClassroomDictionary[board.id] = classroom;
    });
  });
  return boardsClassroomDictionary;
};

export const setClassroomsGroups = (
  classrooms: ClassroomModel[],
  boardsGroups: BoardsGroupModel[],
): GroupWithClassrooms[] => {
  if (!boardsGroups || !boardsGroups.length) return [];

  // We should filter by the boardsGroup type, but since we still don't have this returning from the backend
  // we're getting the first boardsGroup
  const [firstBoardsGroup] = boardsGroups;
  const { groups } = firstBoardsGroup;

  const boardsClassroomDictionary = createDictionaryBoardClassroom(classrooms);

  const groupsWithClassrooms = groups.map((group) => {
    const classroomsOfGroup = group.boardIds.reduce((acc: ClassroomModel[], boardId: number) => {
      const classroom = boardsClassroomDictionary[boardId];
      if (classroom) acc.push(classroom);
      return acc;
    }, []);
    return {
      ...group,
      classrooms: classroomsOfGroup,
    };
  });

  return groupsWithClassrooms;
};
